import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { CHANGE_SIGN, DEL_ACCOUNT_FOR_LIST, SESSION_ACCOUNT_LIST, } from './cgi-path';
var AccountListRepository = /** @class */ (function () {
    function AccountListRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    AccountListRepository.prototype.getAccountList = function (padID, folderID) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(SESSION_ACCOUNT_LIST, "?xrsf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf));
                // 返回文件可访问权限
                if (padID) {
                    return [2 /*return*/, this.networkRequestService.instance.get(url, {
                            params: {
                                padID: padID,
                            },
                        })];
                }
                // 返回文件夹可访问权限
                if (folderID) {
                    return [2 /*return*/, this.networkRequestService.instance.get(url, {
                            params: {
                                folderID: folderID,
                            },
                        })];
                }
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountListRepository.prototype.delAccountForList = function (u) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(DEL_ACCOUNT_FOR_LIST, "?xrsf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf), "&u=").concat(u);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    AccountListRepository.prototype.changeSign = function (u) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "".concat(CHANGE_SIGN, "?xrsf=").concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf), "&u=").concat(u);
                return [2 /*return*/, this.networkRequestService.instance.get(url, { withCredentials: true })];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], AccountListRepository.prototype, "getAccountList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountListRepository.prototype, "delAccountForList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AccountListRepository.prototype, "changeSign", null);
    AccountListRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], AccountListRepository);
    return AccountListRepository;
}());
export default AccountListRepository;
